<template>
  <v-row>
    <v-col cols="12" :id="'grafContainer' + typ">
      <div
        class="text-center"
        style="width: 100%; overflow: auto"
        v-if="loading"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-else>
        <bar-chart
          v-if="isBar"
          :chart-data="grafValues"
          :options="grafOptions"
        ></bar-chart>
        <line-chart
          v-if="isLine"
          :chart-data="grafValues"
          :options="grafOptions"
        ></line-chart>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import * as moment from "moment"
import BarChart from "./BarChart.js"
import LineChart from "./LineChart.js"
import Vue from "vue"

export default {
  data: function() {
    return {
      loading: false,
      grafHeaders: [],
      grafData: []
    }
  },
  components: { BarChart, LineChart },
  props: {
    typ: {
      type: String,
      required: true
    },
    stanica: {
      type: Object,
      required: false,
      default: null
    },
    filterRok: {
      type: Number,
      required: false,
      default: moment().year()
    },
    filterRokOd: {
      type: Number,
      required: false,
      default: moment().year()
    },
    filterRokDo: {
      type: Number,
      required: false,
      default: moment().year()
    }
  },
  computed: {
    isBar: function() {
      let ret = true
      if (this.typ === "kumul30dni") {
        ret = false
      }
      if (this.typ === "kumulDlhod2") {
        ret = false
      }
      return ret
    },
    isLine: function() {
      let ret = false
      if (this.typ === "kumul30dni") {
        ret = true
      }
      if (this.typ === "kumulDlhod2") {
        ret = true
      }
      return ret
    },
    isAnyPriemT: function() {
      const notNullValues = this.grafData.filter(i => i.PriemT !== null)
      return notNullValues.length > 0
    },
    isAnyMinimT: function() {
      const notNullValues = this.grafData.filter(i => i.MinimT !== null)
      return notNullValues.length > 0
    },
    grafTitle: function() {
      let ret = ""
      if (this.typ === "monitZaklKlimFaktory") {
        ret = `Vývoj monitorovania klimatických ukazovateľov - ${this.stanica.Stanica} (indikatív ${this.stanica.Indik})`
      }
      if (this.typ === "denneMaxima") {
        ret = `Porovnanie denných zrážkových úhrnov z roku ${this.filterRok} s dlhodobými (${this.filterRokOd} - ${this.filterRokDo}) dennými maximami - ${this.stanica.Stanica} (indikatív ${this.stanica.Indik})`
      }
      if (this.typ === "kumul30dni") {
        ret = `Porovnanie kumulovaných 30 dňových úhrnov z roku ${this.filterRok} s dlhodobými 30 dňovými úhrnmi (${this.filterRokOd} - ${this.filterRokDo}) - ${this.stanica.Stanica} (indikatív ${this.stanica.Indik})`
      }
      if (this.typ === "kumulDlhod1") {
        ret = `Kumulatívne ročné úhrny s postupom 1 deň z roku ${this.filterRok} - ${this.stanica.Stanica} (indikatív ${this.stanica.Indik})`
      }
      if (this.typ === "kumulDlhod2") {
        ret = `Rozdiel medzi úhrnmi z roku ${this.filterRok} a dlhodobými priemernými úhrnmi (${this.filterRokOd} - ${this.filterRokDo}) - ${this.stanica.Stanica} (indikatív ${this.stanica.Indik})`
      }
      return ret
    },
    grafValues: function() {
      let ret = ""
      switch (this.typ) {
        case "monitZaklKlimFaktory":
          ret = {
            labels: this.grafData.map(i => i.Datum),
            //labels: ["January", "February", "March", "April"],
            datasets: [
              {
                label: "Denné úhrny zrážok",
                backgroundColor: "#00bfff",
                borderWidth: 0,
                //data: [10, 20, 30, 40]
                data: this.grafData.map(i => i.Zrazky),
                yAxisID: "y-axis-zrazky"
              },
              {
                label: "Priemerná teplota vzduchu",
                data: this.grafData.map(i => i.PriemT),
                backgroundColor: "#935d5d",
                borderColor: "#935d5d",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line",
                yAxisID: "y-axis-teplota"
              },
              {
                label: "Minimálna teplota vzduchu",
                data: this.grafData.map(i => i.MinimT),
                backgroundColor: "#FF9900",
                borderColor: "#FF9900",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: "false",
                type: "line",
                yAxisID: "y-axis-teplota"
              }
            ]
          }
          // console.log("this.isAnyPriemT", this.isAnyPriemT)
          if (!this.isAnyPriemT) {
            // odstran druhy dataset
            ret.datasets.splice(1, 1)
          }
          // console.log("this.isAnyMinimT", this.isAnyMinimT)
          if (!this.isAnyMinimT) {
            // odstran posledny dataset
            ret.datasets.pop()
          }
          break
        case "denneMaxima":
          ret = {
            labels: this.grafData.map(i => i.Datum),
            datasets: [
              {
                label: `Denné úhrny zrážok z roku ${this.filterRok}`,
                backgroundColor: "#00bfff",
                borderWidth: 0,
                //data: [10, 20, 30, 40]
                data: this.grafData.map(i => i.Zrazky)
              },
              {
                label: `Maximálne zrážky v mesiaci - obdobie ${this.filterRokOd} - ${this.filterRokDo}`,
                data: this.grafData.map(i => i.MaxMes),
                backgroundColor: "#ea8a8a",
                pointRadius: "0",
                borderWidth: "1",
                steppedLine: "before",
                pointStyle: "line",
                fill: "origin",
                type: "line"
              }
            ]
          }
          break
        case "kumul30dni":
          ret = {
            labels: this.grafData.map(i => i.Datum),
            datasets: [
              {
                label: `Kumulatívne úhrny z roku ${this.filterRok} - súčet za 30 dní s postupom 1 deň`,
                backgroundColor: "#00bfff",
                borderWidth: 0,
                pointStyle: "line",
                fill: "origin",
                data: this.grafData.map(i => i.KumZr30Rok)
              },
              {
                label: `30 dňové úhrny vypočítané z priemerných denných úhrnov za obdobie ${this.filterRokOd} - ${this.filterRokDo}`,
                backgroundColor: "#ea8a8a",
                borderWidth: 0,
                pointStyle: "line",
                fill: "origin",
                data: this.grafData.map(i => i.KumZr30RO)
              }
            ]
          }
          break
        case "kumulDlhod1":
          ret = {
            labels: this.grafData.map(i => i.Datum),
            datasets: [
              {
                label: `Denné úhrny zrážok z roku ${this.filterRok}`,
                backgroundColor: "#00bfff",
                borderWidth: 0,
                data: this.grafData.map(i => i.Zrazky),
                yAxisID: "y-axis-zd"
              },
              {
                label: `Kumulatívne zrážky za rok ${this.filterRok}`,
                data: this.grafData.map(i => i.KumulZaRok),
                backgroundColor: "#FF9966",
                borderColor: "#FF9966",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: false,
                type: "line",
                yAxisID: "y-axis-zk"
              },
              {
                label: `Kumulatívne zrážky za obdobie ${this.filterRokOd} - ${this.filterRokDo}`,
                data: this.grafData.map(i => i.KumulZaRO),
                backgroundColor: "#876464",
                borderColor: "#876464",
                pointRadius: "0",
                borderWidth: "1",
                pointStyle: "line",
                fill: false,
                type: "line",
                yAxisID: "y-axis-zk"
              }
            ]
          }
          break
        case "kumulDlhod2":
          ret = {
            labels: this.grafData.map(i => i.Datum),
            datasets: [
              {
                label: `Vypočítaný deficit zrážkových úhrnov v roku ${this.filterRok}`,
                backgroundColor: "#ff0000",
                borderColor: "ff0000",
                borderWidth: 1,
                pointStyle: "line",
                fill: true,
                data: this.grafData.map(i =>
                  i.DeficitRok <= 0 ? i.DeficitRok : null
                )
              },
              {
                label: `Vypočítaný prebytok zrážkových úhrnov v roku ${this.filterRok}`,
                backgroundColor: "#0000ff",
                borderColor: "0000ff",
                borderWidth: 1,
                pointStyle: "line",
                fill: true,
                data: this.grafData.map(i =>
                  i.DeficitRok > 0 ? i.DeficitRok : null
                )
              }
            ]
          }
          break
        default:
          break
      }
      return ret
    },
    grafOptions: function() {
      let ret = ""
      switch (this.typ) {
        case "monitZaklKlimFaktory":
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: this.grafTitle
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "month"
                  }
                }
              ],

              yAxes: [
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: "left",
                  id: "y-axis-zrazky",
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                },
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: "right",
                  id: "y-axis-teplota",
                  // grid line settings
                  scaleLabel: {
                    display: true,
                    labelString: "[°C]"
                  },
                  gridLines: {
                    drawOnChartArea: false // only want the grid lines for one axis to show up
                  }
                }
              ]
            }
          }
          break
        case "denneMaxima":
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: this.grafTitle
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "month"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ]
            }
          }
          break
        case "kumul30dni":
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: this.grafTitle
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "month"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ]
            }
          }
          break
        case "kumulDlhod1":
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: this.grafTitle
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "month"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: "left",
                  id: "y-axis-zk",
                  scaleLabel: {
                    display: true,
                    labelString: "ZK[mm]"
                  }
                },
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  position: "right",
                  id: "y-axis-zd",
                  // grid line settings
                  scaleLabel: {
                    display: true,
                    labelString: "ZD[mm]"
                  },
                  gridLines: {
                    drawOnChartArea: false // only want the grid lines for one axis to show up
                  }
                }
              ]
            }
          }
          break
        case "kumulDlhod2":
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            title: {
              display: true,
              text: this.grafTitle
            },
            legend: { display: true, position: "top" },
            scales: {
              xAxes: [
                {
                  type: "time",
                  time: {
                    unit: "month"
                  }
                }
              ],
              yAxes: [
                {
                  type: "linear", // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: "[mm]"
                  }
                }
              ]
            }
          }
          break
        default:
          break
      }
      return ret
    },
    urlFetch: function() {
      let url = "/r/chart/" + this.typ
      url += "?rok=" + this.filterRok
      url += "&rokOd=" + this.filterRokOd
      url += "&rokDo=" + this.filterRokDo
      url += "&stanicaID=" + this.stanica.ID
      return url
    }
  },
  watch: {
    filterRok: {
      immediate: true,
      handler: function(value) {
        console.log("STANICA_CHART, filterRok changed, fetching data...", value)
        this.show()
      }
    },
    filterRokOd: {
      immediate: true,
      handler: function(value) {
        console.log(
          "STANICA_CHART, filterRokOd changed, fetching data...",
          value
        )
        this.show()
      }
    },
    filterRokDo: {
      immediate: true,
      handler: function(value) {
        console.log(
          "STANICA_CHART, filterRokDo changed, fetching data...",
          value
        )
        this.show()
      }
    }
  },
  methods: {
    show: async function() {
      try {
        console.log("StanicaChart.vue, show")
        this.grafData = []
        this.grafHeaders = []
        this.loading = true
        let response = await this.$axios.get(this.urlFetch)
        this.loading = false
        if (response.status === 200) {
          this.grafData = response.data.data
          this.grafHeaders = response.data.headers
          //this.grafData = this.grafData.concat(this.grafData)
          //this.grafHeaders = this.grafHeaders.concat(this.grafHeaders)
          if (this.grafData === null) {
            this.grafData = []
          }
          if (this.grafHeaders === null) {
            this.grafHeaders = []
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.loading = false
        this.$store.commit("alert", error.toString())
      }
    }
  },
  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    Vue.nextTick(() => {
      this.show()
    })
  }
}

/*
//Download Chart Image
document.getElementById("download").addEventListener('click', function(){
  var url_base64jp = document.getElementById("lineChart").toDataURL("image/jpg");
  var a =  document.getElementById("download");
  a.href = url_base64jp;
});
*/
</script>
